export const questionTypes = [
  { id: 'mc_fillInQuestion', title: 'Create a MC/Fill-In Question', path: '/mycontent/questionsets/mc_fillInQuestion'},
  { id: 'crQuestion', title: 'Create a CR Question', path: '/mycontent/questionsets/cr_Question'},
  { id: 'castleQuestion', title: 'Add Existing Questions', path: '/mycontent/questionsets/questionsSearch/qSet/castle_questions'}
];

export const languages = [
  {
    id: 0,
    name: 'English Only'
  },
  {
    id: 1,
    name: 'Spanish if available'
  }
];